import {GET_GIVEAWAY} from '../actions/giveaway/type'

const initState = {campaign: null}
export default function(state = initState, action) {
    switch(action.type) {
        case GET_GIVEAWAY: 
            return {...state, campaign: action.payload}
        default: return {...state}
    }
}